export const ReportViewTypes = {
  Table: "Table",
  Chart: "Chart"
};
